import Marquee from "react-fast-marquee";

const MESSAGES = [
  "Now launching globally — women's wellness, reimagined",
  "Clinically-formulated with bioavailable, active-form nutrients",
  "Fully transparent labels — no proprietary blends, ever",
  "Vegetarian · Non-GMO · GMP certified",
];

const AnnouncementBar = () => {
  return (
    <div
      data-testid="announcement-bar"
      className="fixed top-0 inset-x-0 z-[60] h-9 flex items-center text-white/90 text-[0.7rem] font-medium tracking-[0.15em] uppercase bg-ink"
    >
      <Marquee speed={34} gradient={false} autoFill>
        {MESSAGES.map((m, i) => (
          <span key={i} className="flex items-center">
            <span className="px-8">{m}</span>
            <span className="text-gold">&#10022;</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default AnnouncementBar;
